import { HeartRateStep, IHeartRateMonitors } from 'fitbeat.models';
import React from 'react';
import { SafeAreaView, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { ThemeType } from '../../theme';
import { createUserServiceClient } from '../../utils/apiClientFactory';
import { defaultScale } from '../../utils/scaling';
import { StartListeningForHeartRateData } from '../heartRateActions';
import { ConsumerType, HeartRateMonitorSetup } from './HeartRateMonitorSetup';

const updateUserHeartRateMonitors = async (heartRateMonitors: IHeartRateMonitors) => {
    const userServiceClient = createUserServiceClient();
    return userServiceClient.updateUserHeartRateMonitors(heartRateMonitors);
}

const HomeWorkoutHeartRateSetupComponent = (props) => {
    return <SafeAreaView style={[styles.modalContainer, props.modalContainer]}>
        <View style={[styles.innerModalContainer, props.bodyStyle]}>
            <HeartRateMonitorSetup
                consumer={ConsumerType.nonModal}
                themeType={ThemeType.dark}
                userProfile={props.userProfile}
                initialStepForUsersWithBelts={HeartRateStep.TEST_BELT}
                heartRateScanAction={StartListeningForHeartRateData}
                updateUserHeartRateMonitors={updateUserHeartRateMonitors}
                {...props}>
            </HeartRateMonitorSetup>
        </View>
    </SafeAreaView>;
};

const HomeWorkoutHeartRateModalComponent = (props) => {
    return <HeartRateMonitorSetup
        consumer={ConsumerType.homeWorkoutModal}
        themeType={ThemeType.dark}
        userProfile={props.userProfile}
        initialStepForUsersWithBelts={HeartRateStep.TEST_BELT}
        heartRateScanAction={StartListeningForHeartRateData}
        updateUserHeartRateMonitors={updateUserHeartRateMonitors}
        {...props}>
    </HeartRateMonitorSetup>;
};

const styles = StyleSheet.create({
    modalContainer: {
        flex: 1,
    },
    innerModalContainer: {
        flex: 1,
        padding: defaultScale(15),
        paddingTop: 0,
    },
});

const mapStateToProps = (state: any) => {
    return {
        userProfile: state.homeWorkouts.userProfile,
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
    return {};
};

export const HomeWorkoutHeartRateSetup =
    connect(mapStateToProps, mapDispatchToProps)(HomeWorkoutHeartRateSetupComponent);

export const HomeWorkoutHeartRateModalSetup =
    connect(mapStateToProps, mapDispatchToProps)(HomeWorkoutHeartRateModalComponent);
